import Vue from 'vue'
import VueRouter, {
  NavigationGuard,
  NavigationGuardNext,
  Route,
  RouteConfig
} from 'vue-router'

import Layout from '../layout/index.vue'
import Logout from '../views/Logout.vue'
import NotFound from '../views/NotFound.vue'

import { UserModule } from '@/store/modules/user'
import i18n from '@/lang'

import { DocumentDetailsRoute } from '@/features/document-details/router/document-details'
import { ContractsRoute } from '@/features/contracts/router/contracts'
import { ActeAditionaleRoute } from '@/features/acte-aditionale/router/acte-aditionale'
import { ActeAditionaleGrupareContracteRoute } from '@/features/acte-aditionale-grupare-contracte/router/acte-aditionale-grupare-contracte'
import { GrupareContracteRoute } from '@/features/grupare-contracte/router/grupare-contracte'
import { ConfigurareAplicatieRoutes } from '@/features/configurare-aplicatie/router/configurare-aplicatie'
import { ProfileRoute } from '@/features/profile/router/profile'
import { LicitatieAchizitieRoute } from '@/features/licitatie-achizitie/router/licitatie-achizitie'
import { OfertaLicitatieAchizitieRoute } from '@/features/oferta-licitatie-achizitie/router/oferta-licitatie-achizitie'
import { PartnerRoute } from '@/features/partners/router/partners'
import { AccesSecuritateRoutes } from '@/features/acces-securitate/router/acces-securitate'
import { NotificationSubscriptionRoute } from '@/features/notification-subscription/router/notification-subscription'
import { UserNotificationsRoute } from '@/features/user-notifications/router/user-notifications'
import { NotificationsRedirectRoute } from '@/features/user-notifications/router/notifications-redirect-route'

Vue.use(VueRouter)

const routes: Array<RouteConfig> = [
  {
    path: '/',
    component: Layout,
    redirect: '/dashboard',
    children: [
      {
        path: 'dashboard',
        component: () =>
          import(/* webpackChunkName: "dashboard" */ '@/views/Dashboard.vue'),
        name: 'DashboardRoute',
        meta: {
          title: 'Dashboard',
          requiresAuth: true
        }
      }
    ]
  },
  PartnerRoute,
  ContractsRoute,
  ActeAditionaleRoute,
  ActeAditionaleGrupareContracteRoute,
  GrupareContracteRoute,
  DocumentDetailsRoute,
  LicitatieAchizitieRoute,
  OfertaLicitatieAchizitieRoute,
  ConfigurareAplicatieRoutes,
  AccesSecuritateRoutes,
  ProfileRoute,
  NotificationSubscriptionRoute,
  UserNotificationsRoute,
  NotificationsRedirectRoute,
  {
    path: '/login',
    component: () =>
      import(/* webpackChunkName: "login" */ '@/views/Login.vue'),
    meta: {
      title: 'LoginRouteTitle'
    }
  },
  {
    path: '/logout',
    name: 'logout',
    component: Logout,
    meta: {
      title: 'LogoutRouteTitle'
    }
  },
  {
    path: '*',
    name: 'NotFound',
    component: NotFound
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

const getPageTitle = (key: string): string => {
  // TODO: translate static part
  const translatedRoute = i18n.te(`route.${key}`)
    ? i18n.t(`route.${key}`).toString()
    : key

  return `${translatedRoute} ${i18n.t('route.globalSuffix')}`.trim()
}

const beforeGuard: NavigationGuard = async (
  to: Route,
  from: Route,
  next: NavigationGuardNext
) => {
  // requires auth
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    await UserModule.refreshSessionData()
    if (UserModule.username === null) {
      next({
        path: '/login',
        params: { nextUrl: to.fullPath }
      })
    } else {
      next()
    }
  } else {
    // guests
    next()
  }
}

const afterEach = (to: Route) => {
  // set page title
  document.title = getPageTitle(to?.meta?.title)
}

router.beforeEach(beforeGuard)
router.afterEach(afterEach)

export default router
